import { render, staticRenderFns } from "./SupportRequestModal.vue?vue&type=template&id=6fc05e9c"
import script from "./SupportRequestModal.vue?vue&type=script&lang=js"
export * from "./SupportRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports